import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../../core/services/session-state.service';
import { House } from '../../houses/houses.model';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material';
import { EditAddressDialogComponent } from '../edit-address-dialog/edit-address-dialog.component';
import { HousesService } from '../../houses/houses.service';
import { ProfileUtils } from '../profile.model';
import { GeneralService } from '../../../shared/services/general.service';
import { HomeService } from '../../home/home.service';

@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss']
})
export class ProfileDetailsComponent implements OnInit {

  house: House;
  loading = true;
  houseTariff = {
    'energy': {
      'costRate': {
        'ENS': 0,
        'ENVN': 0,
        'ENFV': 0,
        'ENV': 0,
        'ENP': 0,
        'ENC': 0
      }
    },
    'cycle': null,
    'power': {
      'contracted': 0,
      'costRate': 0
    },
    'hourOption': null
  };

  constructor(
    private sessionStateService: SessionStateService,
    private housesService: HousesService,
    private generalService: GeneralService,
    private homeService: HomeService,
  ) {
  }

  ngOnInit() {
    this.loadHouse();
  }

  loadHouse() {
    if (this.sessionStateService.getHouse()) {
      this.house = this.sessionStateService.getHouse();
      this.housesService.getHouses().subscribe(data => {
        data.forEach(element => {
          if (element.houseId === this.house.houseId ) {
            this.house = element;
            this.loading = false;
          }
        });
      });
      this.housesService.getHouseTariff(this.house.houseId).subscribe(data => {
        this.houseTariff = data['electricity'];
        this.loading = false;
      });
      /*
      this.housesService.getHouseContractedPower(this.house.houseId).subscribe(data => {
        console.log('/houses/{houseid}/contractedpower');
        console.log(data);
      });
      this.homeService.getHouseTariff(this.house.houseId).subscribe(data => {
        console.log('/equipment/houses/${houseId}/currenttariff');
        console.log(data);
      });
      */
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/profile/profile-details/profile-details.component.ts